import { render, staticRenderFns } from "./BulkCreateProductsModal.vue?vue&type=template&id=17124240&scoped=true&"
import script from "./BulkCreateProductsModal.vue?vue&type=script&lang=ts&"
export * from "./BulkCreateProductsModal.vue?vue&type=script&lang=ts&"
import style0 from "./BulkCreateProductsModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BulkCreateProductsModal.vue?vue&type=style&index=1&id=17124240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17124240",
  null
  
)

export default component.exports